import { getChannelAPIPath } from '@treasury/core/http';
import { createUniqueId } from '@treasury/utils';

GenerateReportService.$inject = ['$resource'];

export default function GenerateReportService($resource) {
    const resourceUrl = `${getChannelAPIPath()}generatereport/?type=:type`;
    return {
        generateReport,
    };

    function generateReport(type, filterMessage) {
        return $resource(resourceUrl, { type }).save(filterMessage).$promise.then(response => {
            // use to determine if report value has changed with $scope.watch()
            response.clientId = createUniqueId();
            return response;
        });
    }
}
